import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/Button';
import { Quote, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
const TESTIMONIALS = [{
  quote: 'What makes Denise uniquely qualified as a professional, she can assist with staging, furnishings and remodeling while under her direction and will keep a watchful eye until the job is complete. Denise has a wealth of knowledge and experience in the community that leads to customer satisfaction with a broad appeal to both home buyers and sellers. Without hesitation I recommend Down Home Interiors.',
  author: 'Carol Griffith',
  location: 'Howell, MI',
  project: 'Broker & Co Owner of Griffith Realty'
}, {
  quote: 'Denise and her staff completed our commercial office building a few years ago transforming the space into a warm and inviting experience. Denise has proven that an office environment does not have to be sterile. We receive comments daily on the physical and cultural setting Denise created for our staff and clients. It really feels like home away from home.',
  author: 'Mike Cosgrove',
  location: 'Brighton, MI',
  project: 'Business Owner PCIA'
}, {
  quote: 'I have had Denise Down stage homes for my clients and every single one sold! Denise works closely with my clients and is also great at communicating with me, the listing agent. If you are a Realtor you know how much goes into timing the listing. Denise and her team are fast, efficient and her work cannot be matched.',
  author: 'Lida Athearn',
  location: 'Fenton, MI',
  project: 'Real Estate Broker'
}, {
  quote: "Having been involved in several commercial construction projects, never did I think the interior design phase could go so smoothly. Denise Down of Down Home Interiors, in Howell, MI made the project not only smooth but beautiful. Her eye for color and creativity surpassed all of my expectations. Not only am I happy with the completed Inn, the customers rave about the decorating. Denise's ability to transition with all types of decor shows on this project. My Inn has four themed rooms representing all different decors. From lodge to contemporary, Denise handled every detail including paint color, bedding, granite, tile, window treatments, and wall decor. I would highly recommend Denise to anyone considering a home or commercial renovation.",
  author: 'Harvey Bartel',
  location: 'Alden, MI',
  project: 'Owner The Inn at Torch Lake'
}, {
  quote: 'Building a new home with Denise and her entire staff at Down Home Interiors was a wonderful experience. We will never forget the professionalism, friendliness, warmth and genuine concern to help satisfy our decorating needs. The service was outstanding. Our home décor from furniture, draperies, area rugs, lamps, floral arrangements and every little intricate detail is gorgeous. Denise also handled all of our concerns with the building process during and while we were away on vacation for 3 weeks. She coordinated everything from start to finish, including assisting with cabinet selections, granite, flooring, etc. It all blends beautifully. Everyone says our home looks like a model, but also with much warmth and coziness. My husband and I are so thankful to Denise and her staff. Lastly she was aware of certain budget constraints we had and always kept that in mind.',
  author: 'Tom & Linda',
  location: 'Pinckney, MI',
  project: 'New Construction'
}, {
  quote: 'Down Home Interiors (DHI) became our source for all home decorating shortly after we moved back to Brighton three years ago. Our Real Estate Agent gave us a gift certificate to DHI and that started a wonderful relationship with DHI and Denise Down. Denise is the consummate professional home decorator who has helped us make our home beautiful and comfortable. She is exceptionally knowledgeable, talented, honest, caring and can nearly read your mind as she communicates ideas and suggestions in all areas of home decorating that bring out the best in you and your home. She always seeks out the best value for her clients and seems to have endless sources for products and services needed to address any project. You name it and Denise can handle it. In the process of working with Denise and her very talented team we have become great friends. We highly recommend Down Home Interiors as a one-stop source for any home decorating / staging project.',
  author: 'Barbara and Ted',
  location: 'Brighton, MI',
  project: 'Home Decorating'
}];
export function Testimonials() {
  return <Layout data-id="element-765">
      {/* Hero Section */}
      <section className="relative py-32 px-4 border-b border-taupe-200 overflow-hidden" data-id="element-766">
        {/* Background Image */}
        <div className="absolute inset-0" data-id="element-767">
          <img src="https://cdn.magicpatterns.com/uploads/v8sYnnavuXqFekBRovHgC9/Testimonials_bg2.jpg" alt="Down Home Interiors Retail Store" className="w-full h-full object-cover" data-id="element-768" />
          <div className="absolute inset-0 bg-white/80" data-id="element-769" />
        </div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-770">
          <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-6 block" data-id="element-771">
            Client Testimonials
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal-900 mb-6 leading-tight" data-id="element-772">
            What Our Clients
            <br data-id="element-773" />
            <span className="italic" data-id="element-774">Are Saying</span>
          </h1>
          <p className="text-xl text-charcoal-900/70 leading-relaxed max-w-2xl mx-auto" data-id="element-775">
            Two decades of trust, hundreds of satisfied clients, and
            relationships that last beyond the project.
          </p>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-20 px-4 bg-white border-b border-taupe-200" data-id="element-776">
        <div className="max-w-4xl mx-auto text-center" data-id="element-777">
          <h2 className="text-2xl md:text-3xl font-serif text-charcoal-900 mb-6" data-id="element-778">
            Built on Trust and Results
          </h2>
          <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-779">
            Our reputation has been built one satisfied client at a time. Many
            of our customers return for multiple projects over the years, and
            referrals from happy clients remain our primary source of new
            business.
          </p>
          <p className="text-lg text-charcoal-900/70 leading-relaxed" data-id="element-780">
            These testimonials represent real feedback from real projects. We're
            proud of the relationships we've built and the spaces we've created
            together.
          </p>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-781">
        <div className="max-w-7xl mx-auto" data-id="element-782">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-783">
            {TESTIMONIALS.map((testimonial, index) => <div key={index} className="bg-white p-8 border border-taupe-200 shadow-card relative flex flex-col" data-id="element-784">
                <Quote className="absolute top-6 left-6 text-sage-200 h-10 w-10" data-id="element-785" />

                <div className="relative z-10 pt-10 flex-grow" data-id="element-786">
                  <p className="text-charcoal-900/70 italic mb-6 leading-relaxed" data-id="element-787">
                    "{testimonial.quote}"
                  </p>
                </div>

                <div className="border-t border-taupe-100 pt-6 mt-4" data-id="element-788">
                  <div className="flex items-center gap-1 mb-3" data-id="element-789">
                    {[...Array(5)].map((_, i) => <Star key={i} className="text-sage-500 fill-sage-500" size={14} data-id="element-790" />)}
                  </div>
                  <p className="font-serif font-medium text-charcoal-900 mb-1" data-id="element-791">
                    {testimonial.author}
                  </p>
                  <p className="text-xs text-charcoal-900/50 uppercase tracking-wide mb-1" data-id="element-792">
                    {testimonial.location}
                  </p>
                  <p className="text-xs text-sage-600 italic" data-id="element-793">
                    {testimonial.project}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 px-4 bg-white" data-id="element-794">
        <div className="max-w-5xl mx-auto" data-id="element-795">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center" data-id="element-796">
            <div data-id="element-797">
              <div className="text-5xl font-serif text-sage-500 mb-3" data-id="element-798">20+</div>
              <p className="text-lg text-charcoal-900/70" data-id="element-799">Years in Business</p>
            </div>
            <div data-id="element-800">
              <div className="text-5xl font-serif text-sage-500 mb-3" data-id="element-801">500+</div>
              <p className="text-lg text-charcoal-900/70" data-id="element-802">Projects Completed</p>
            </div>
            <div data-id="element-803">
              <div className="text-5xl font-serif text-sage-500 mb-3" data-id="element-804">95%</div>
              <p className="text-lg text-charcoal-900/70" data-id="element-805">
                Client Referral Rate
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-4 bg-gradient-to-br from-taupe-200/50 to-cream-100" data-id="element-806">
        <div className="max-w-4xl mx-auto text-center" data-id="element-807">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-808">
            Ready to Join Our Family of Satisfied Clients?
          </h2>
          <p className="text-xl text-charcoal-900/70 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-809">
            Let's start a conversation about your design needs. We'd love to add
            your success story to our portfolio.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-810">
            <a href="tel:5175455955" data-id="element-811">
              <Button size="lg" className="min-w-[200px]" data-id="element-812">
                Call to Get Started
              </Button>
            </a>
            <Link to="/store-info" data-id="element-813">
              <Button variant="outline" size="lg" className="min-w-[200px]" data-id="element-814">
                Visit Our Retail Store
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>;
}